// src/pages/Terms.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import './blog/Blog.css';

const Terms: React.FC = () => {
  return (
    <div className="blog-page">
      <Helmet>
        <title>Terms of Service | Cosmic Kavi</title>
        <meta name="description" content="Terms of Service for Vedic Astrology and Vaastu Shastra consultations with Astrologer Kavitha Nandy." />
        <meta name="robots" content="noindex, follow" />
        <link rel="canonical" href="https://cosmickavi.com/terms" />
      </Helmet>

      <div className="blog-container">
        <Link to="/" className="blog-back">← Back to Home</Link>

        <div className="blog-hero">
          <span className="blog-category">Policies</span>
          <h1><span>Terms of Service</span></h1>
        </div>

        <article className="blog-body">
          <p>
            Vedic Astrology or Jyotish Shastra is a time-honored wisdom from India that uses your birth date,
            birth time and birth place to reveal your life's roadmap about your career, relationships, health,
            wealth, progeny, inheritance, karma and more, through planetary cycles.
          </p>
          <p>
            Vaastu Consultancy or Vaastu Shastra is India's traditional science of architecture and space design
            based on directional energy flow and the five elements. It creates balance between your environment
            and your life. Some compare it to Feng Shui, but it has its own distinct and deeper roots. Home/Office
            layout and inspection of home/office interiors and furniture is required for consulting, remedies and
            corrections.
          </p>

          <h2>What to Expect</h2>
          <p>
            Your Vedic Astrology - whole life reading session will be a natal chart and divisional charts reading
            with focus on relationships, career, finance, health or any specific question you may have. Astrology
            provides guidance and clarity, but your free will and choices shape the outcome.
          </p>

          <h2>Privacy</h2>
          <p>
            Your birth details and discussions are completely confidential.
          </p>

          <h2>Disclaimer</h2>
          <p>
            By booking a session, you agree to provide your birth details (date, time and place) at your own
            discretion for the purpose of preparing your horoscope. These terms, conditions, disclaimer and
            policies may be updated or changed at any time. As an independent astrologer/astrological business,
            I reserve the right to make such changes when required. This allows me to keep policies clear, fair
            and up to date as my services grow and evolve, while continuing to provide the best possible guidance
            and experience.
          </p>

          <h2>Your Role</h2>
          <p>
            Please share your accurate birth details (date, time and place) before the session, as this will help
            in the accuracy of predictions. Come with your questions or areas of focus so we can dive deep. For
            questions related to children, relationships, business partnerships, progeny or family matters,
            accurate birth details of children, spouse, business partners or parents may also be required
            depending on the type of question. A one-hour session ($60), typically a whole life reading, allows
            us to explore three to four life areas of a horoscope. A half hour session ($25) focuses on any one
            area of life or any one burning question you may have.
          </p>

          <h2>Important Note</h2>
          <p>
            Astrology is not a substitute for medical, legal, psychological or financial advice. Remedies such as
            mantras, gemstones or Vaastu recommendations for home or office are offered as supportive tools, not
            guarantees.
          </p>
          <p>
            Sessions missed without 24-hour notice may not be guaranteed immediate appointment availability.
          </p>
          <p>
            By booking a session you acknowledge Astrology and Vaastu as tools for self-discovery.
          </p>
          <p>
            By proceeding with the session and sharing birth details, you agree to all the guidelines and
            disclaimer mentioned above. Astrology and Vaastu consultations are intended for personal insight.
            All decisions and actions remain your responsibility.
          </p>
        </article>
      </div>
    </div>
  );
};

export default Terms;
